<template>
	<div style="padding: var(--page-padding); height: var(--content-height)">
		
	</div>
</template>

<script>
export default {
	data() {
		return { }
	},
	created() { },
	mounted() { },
	components: { },
	methods: { }
}
</script>

<style>


</style>
